import { render, staticRenderFns } from "./detailDrv.vue?vue&type=template&id=69ac7c80&scoped=true"
import script from "./detailDrv.vue?vue&type=script&lang=js"
export * from "./detailDrv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ac7c80",
  null
  
)

export default component.exports